import { createSlice, PayloadAction } from "@reduxjs/toolkit";
let accountSetupState = {
  accountId: "",
  subAccountId: "",
};

const accountSetUpSlice = createSlice({
  name: "accountSetUpDetails",
  initialState: { ...accountSetupState },
  reducers: {
    setAccountDetails: (state: any, action: PayloadAction<any>) => {
      state = { ...state, ...action.payload };
      return state;
    },
  },
});

export const { setAccountDetails } = accountSetUpSlice.actions;
export default accountSetUpSlice.reducer;
